import { render } from "./TransformForm.vue?vue&type=template&id=57ff6332&ts=true"
import script from "./TransformForm.vue?vue&type=script&lang=ts"
export * from "./TransformForm.vue?vue&type=script&lang=ts"

import exportComponent from "/codebuild/output/src678506843/src/babyhead-viewer/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__